<template>
  <div @click="hiddenRight()" @contextmenu="hiddenRight()">
    <el-dialog
      class="orcode tx-c"
      title="微信绑定"
      :visible.sync="showBinding"
      width="430px"
    >
      <img :src="imgurl" />
    </el-dialog>
    <el-dialog
      class="orcode tx-c"
      :showClose="false"
      :close-on-click-modal="false"
      title="确认登录类型"
      :visible.sync="identityBind"
      width="600px"
    >
      <div>
        <el-form
          :model="ruleForm"
          ref="dynamicValidateForm"
          label-width="80px"
          class="demo-dynamic"
        >
          <el-form-item prop="identityType" label="类型">
            <el-select
              size="mini"
              v-model="ruleForm.identityType"
              placeholder="请选择"
              @change="identityTypeChange"
              style="width: 100%"
            >
              <el-option
                v-for="item in optionsType"
                :key="item.Key"
                :label="item.lable"
                :value="item.Key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="isShowEaraName" prop="eareaName" label="物业区域">
            <el-input
              size="mini"
              v-model="ruleForm.eareaName"
              @click.native="openWyQuery()"
              placeholder="请选择"
            ></el-input>
          </el-form-item>
        </el-form>
        <!-- <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="70px"
          class="demo-ruleForm"
         >
          
          <el-form-item v-if="isShowEaraName" label="物业区域" prop="eareaName">
            <el-input v-model="ruleForm.eareaName" @click.native="openWyQuery()" placeholder="请选择"></el-input>
          </el-form-item>
        </el-form>-->
        <div style="display: flex; flex-direction: row-reverse">
          <el-button size="mini" type="primary" @click="submitForm('ruleForm')"
            >确认
          </el-button>
        </div>
      </div> 
    </el-dialog>
    <el-container>
      <!-- :style="{height:containerHeader+'rem'}" -->
      <el-header :style="{ height: '65px' }" v-if="Concealtitle">
        <div class="nav">
          <!--          <span style="display: flex; padding-left: 20px; line-height: 65px">-->
          <!--            <img class="logo" src="@/assets/img/menu/头部图标.png" alt />-->
          <!--            <span style="font-weight: 400; font-size: 25px"-->
          <!--              >广东政务服务网 |</span-->
          <!--            >-->
          <!--            <span-->
          <!--              style="line-height: 75px; font-size: 14px; letter-spacing: 2px"-->
          <!--              >深圳市住房和建设局-{{ systemConfig.BisWebSiteName }}</span-->
          <!--            >-->
          <!--          </span>-->
          <div class="header-main" v-if="showKey()">
            <h1 class="header-logo">
              <a href="#" @click.prevent="confirmOut" class="">{{ showKey('广东政务服务网') }}</a>
            </h1>
            <div class="header-title icon-vertical_line iconfont">
              <span>{{ showKey('深圳市住房和建设局') }}</span>
            </div>
            <div class="header-title2 icon-vertical_line iconfont">
              <span>{{ showKey(systemConfig.BisWebSiteName) }}</span>
            </div>
          </div>
          <!-- 暂时关闭 -->
          <!-- <ul class="menuList">
          <li @click="goIndex()">首页</li>
          <template v-if="menuList.length>0">
            <li
              v-for="(item,index) in menuList"
              :key="index"
              @click="goRouter(item)"
            >{{item.name}}</li>
          </template>
          <li @click="handelNavGroup">
            自定义
            <i
              class="el-icon-plus"
              style="margin:0 4px"
            ></i>
          </li>
          </ul>-->
          <!-- <div class="menuList">
          <el-menu
            class="el-menu-demo"
            mode="horizontal"
            background-color="#4895e0"
            text-color="#fff"
            active-text-color="#fff"
            :router="true"
          >
            <el-menu-item index="index">首页</el-menu-item>
            <el-submenu v-for="(item,index) in menuList" :key="index" :index="item.name">
              <template slot="title">{{item.name}}</template>
              <el-menu-item
                v-for="(childItem ,childIndex) in item.children"
                :key="childIndex"
                :index="childItem.path"
              >{{childItem.name}}</el-menu-item>
            </el-submenu>
            <el-menu-item index="index" @click="handelNavGroup">
              自定义</el-menu-item>
          </el-menu>
          </div>-->
          <ul class="navRight ub-f1 ft16">
            <li style class="sel-input ub ub-pc">
              <!-- <el-input
                placeholder="请输入内容"
                prefix-icon="el-icon-search"
                size="mini"
                v-model="searchVal"
                @keyup.enter.native="EnterSearch()"
              ></el-input> -->
            </li>
            <li class="binding" @click="showCode()" v-if="!isBinding">绑定</li>
            <li class="binding" @click="unbound()" v-if="isBinding">
              解除绑定
            </li>
            <li v-if="messageCount === 0" @click="showMessage">
              <!-- <i class="el-icon-message"></i>  -->
            </li>
            <li v-else>
              <el-badge :value="messageCount" :max="99" class="item">
                <i class="el-icon-message"></i>
              </el-badge>
            </li>
            <li style="min-width: 64px">
              <span @click="EnterPersonalCenter()">{{
                userInfo.FullName
              }}</span>

              <!-- 修改密码  个人信息 -->
              <!-- <el-dropdown>
                <span class="el-dropdown-link">
                  <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="EnterPersonalCenter()">
                    <i class="el-icon-info"></i>个人信息
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="passwordVisible = true">
                    <i class="el-icon-edit"></i>修改密码
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>-->
            </li>
            <li @click="showUserTypeSelect">{{ userRoleInfo.ROLE }}</li>
            <li style="min-width: 32px" class="logout_title" @click="logout()">
              <svg-icon icon-class="exit" class="iconstyle"></svg-icon>
              退出
            </li>
            <!--            <li-->
            <!--              style="min-width: 32px; font-weight: 600"-->
            <!--              class="logout_title"-->
            <!--              @click="goHome()"-->
            <!--            >-->
            <!--              返回首页-->
            <!--            </li>-->
            <li v-if="showKey()">
              <a
                href="http://zjj.sz.gov.cn"
                title="首页"
                target="_blank"
                class="iconfont icon-home"
                style="color: white"
                >官网首页</a
              >
            </li>
          </ul>
          <!--<change-password @close="showPasswordDialog()" :centerDialogVisible="passwordVisible"></change-password>-->
          <!--  -->
        </div>
        <div
          class="menuSearchBox"
          :class="{ menuSearchBoxShow: isShowMenuSearch }"
        >
          <div class="header">
            <div class="menu-search"></div>
            <span class="close" @click="closeMenuSearch">
              <svg-icon icon-class="close" />
            </span>
          </div>
          <div class="menu-box-container">
            <div class="module" v-for="(item, index) in router" :key="index">
              <div class="module-title">{{ item.name }}</div>
              <ul>
                <template v-for="(childItem, childIndex) in item.children">
                  <li v-if="childItem.meta.isShowMenu" :key="childIndex">
                    {{ childItem.name }}
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div>
      </el-header>
      <!-- :width="asidewidth+'rem'" -->
      <el-container style="display: flex">
        <el-aside :width="asidewidth + 'px'" v-if="showleft">
          <div class="menu-left" id="manue">
            <div class="open" @click="showhide(false)" v-if="isCollapse">
              <i class="el-icon-arrow-right"></i>
            </div>
            <div class="close" @click="showhide(true)" v-if="!isCollapse">
              <i class="el-icon-arrow-left"></i>
            </div>

            <el-menu
              class="el-menu-vertical-demo sidebar"
              @open="handleOpen"
              @close="handleClose"
              :router="true"
              :collapse="isCollapse"
            >
              <el-menu-item
                disabled
                index="index"
              >
                <i class="el-icon-menu"></i>
                <span slot="title" style="font-size: 16px; font-weight: bold"
                  >目录</span
                >
              </el-menu-item>
              <template v-for="(item, index) in router">
                <el-submenu
                  v-if="item.meta.isShowMenu"
                  :key="index"
                  :index="item.name"
                >
                  <template slot="title">
                    <svg-icon class="iconStyle" :icon-class="item.meta.icon" />
                    <span slot="title">{{ item.name }}</span>
                  </template>
                  <template v-for="(childItem, childIndex) in item.children">
                    <template
                      v-if="childItem.children && childItem.children.length > 0"
                    >
                      <el-submenu
                        v-if="childItem.meta.isShowMenu"
                        :key="`${index}-${childIndex}`"
                        :index="childItem.name"
                      >
                        <template slot="title">{{ childItem.name }}</template>
                        <template
                          v-for="(
                            childItem2, childIndex2
                          ) of childItem.children"
                        >
                          <el-menu-item
                            v-if="childItem2.meta.isShowMenu"
                            :key="childIndex2"
                            :index="childItem2.path"
                            @click="linkTo(childItem2.path)"
                            >{{
                              // @click="linkTo(childItem2.path)"
                              childItem2.name
                            }}
                          </el-menu-item>
                        </template>
                      </el-submenu>
                    </template>
                    <template v-else>
                      <el-menu-item
                        class="menu-item-1"
                        v-if="childItem.meta.isShowMenu"
                        :key="childIndex"
                        :index="childItem.path"
                        @click="linkTo(childItem.path)"
                      >
                        {{ childItem.name }}
                      </el-menu-item>
                    </template>
                  </template>
                </el-submenu>
              </template>
            </el-menu>
          </div>
        </el-aside>
        <el-container>
          <el-header style="height: 50px">
            <div class="currentPages">
              <!-- <div class="return">
              <i class="el-icon-back"></i>
              </div>-->
              <div class="breadcrumb">
                <div class="left-btn">
                  <i
                    class="el-icon-arrow-left"
                    v-show="isShowBtn"
                    @click="leftHandle()"
                  ></i>
                </div>
                <!-- tabs -->
                <div class="routerLink clearfix">
                  <ul class="scorllTab" id="scorllTab" style="left: 0">
                    <li
                      class="tabs-item"
                      v-bind:class="[index === activeIndex ? 'active' : '']"
                      v-for="(item, index) in tabsRouter"
                      :key="item.path"
                      @click="tabsHandle(item, index)"
                      @contextmenu.prevent="rightShow($event, index)"
                    >
                      <span
                        v-if="getMetaName(item)"
                        >{{ item.meta.name }}</span
                      >
                      <span v-else>{{ item.name }}</span>
                      <!-- <span>{{ item. }}</span> -->
                      <i
                        class="el-icon-close"
                        @click.stop="tabsDelete(index)"
                        v-show="index != 0"
                      ></i>
                    </li>
                    <el-card
                      class="box-card"
                      v-if="showright"
                      :style="rightStyle"
                    >
                      <div @click="closetabs('left')">
                        <i class="el-icon-arrow-left"></i>关闭左边
                      </div>
                      <div @click="closetabs('right')">
                        <i class="el-icon-arrow-right"></i>关闭右边
                      </div>
                      <div @click="closetabs('others')">
                        <i class="el-icon-close"></i>关闭其他
                      </div>
                    </el-card>
                  </ul>
                </div>
                <div class="right-btn">
                  <i
                    class="el-icon-arrow-right"
                    v-show="isShowBtn"
                    @click="rightHandle()"
                  ></i>
                </div>
              </div>
            </div>
          </el-header>
          <el-main class="pagebox">
            <!-- 测试中使用keep-alive -->
            <keep-alive v-if="show">
              <router-view
                @getShopCode="getShopCode"
                :key="$route.path + $route.query.t"
                v-if="$route.meta.keepAlive"
              ></router-view>
            </keep-alive>
            <router-view
              @getShopCode="getShopCode"
              :key="$route.path + $route.query.t"
              v-if="!$route.meta.keepAlive"
            ></router-view>
          </el-main>
          <el-footer v-if="showKey()">
            <div class="footer">
              <!-- 底部主体区 占比两边各留7% 上下各留20px -->
              <div class="footer-container">
                <div class="footer-r">
                  <ul>
                    <li>
                      <b>联系我们</b>
                      <dd>0755-82794696</dd>
                    </li>
                    <li style="display: flex">
                      <a
                        href="https://zfwzgl.www.gov.cn/exposure/jiucuo.html?site_code=4403000005&url=https%3A%2F%2Fzjj.sz.gov.cn%2Fszwyweb%2F%23%2Findex"
                        target="_blank">
                      <img src="@/assets/img/menu/政府找错.png">
                    </a>
                      <a
                      href="#" @click.prevent="confirmAndRedirect"
                      >
                        <img src="@/assets/img/menu/党政机关网站标识.png" />
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="footer-l">
                  <ul>
                    <li class="line1">
                      <b>主办单位：</b>
                      <dd>{{ showKey('深圳市住房和建设局') }}</dd>
                    </li>
                    <li>
                      <b>备 案 号：</b>
                      <dd>
                        <a
                          href="#"
                          @click.prevent="getICP"
                          title="粤ICP备2023053213号"
                        >
                          {{ showKey('粤ICP备2023053213号') }}
                        </a>
                      </dd>
                    </li>
                    <li>
                      <b>网站标识码：</b>
                      <dd>4403000005</dd>
                    </li>
                    <li>
                      <dd>
                        <a 
                          href="#"
                          @click.prevent="getYGA"
                          title="粤公网安备 44030402002800号"
                          ><img
                            src="@/assets/img/menu/公安机关备案标识.png"
                          />粤公网安备 44030402002800号
                        </a>
                      </dd>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </el-footer>
        </el-container>
      </el-container>
    </el-container>
    <!-- 判断是否绑定总公司 -->
    <head-quarters
      @close="showquartersDialog()"
      :centerDialogVisible="quartersVisible"
    ></head-quarters>

    <ea-area-mge
      v-if="identityBind"
      :checkbox="checkBox"
      :isMessage="isMessageText"
      :selectArr="selectArr"
      :orgCode="userInfo.UserParam.orgCode"
      @propertyVal="property"
      @propertyValArr="propertyValArr"
    ></ea-area-mge>
    <el-dialog title="角色列表" :visible.sync="showUserTypeList" width="30%">
      <div class="user-box">
        <template v-for="(item, index) of userRoleInfo.RoleList">
          <div
            class="user-list"
            :class="{ activeUser: item.Id == userRoleInfo.ID }"
            @click="handleSelectUser(item)"
          >
            {{ item.Remark }}
          </div>
        </template>
      </div>
    </el-dialog>
    <help-icon></help-icon>
  </div>
</template>

<script>
import mouseToLeft from '@/directives/mouseToLeft';
import VueScriptComponent from 'vue-script-component';
import { mapState, mapActions, mapMutations } from 'vuex';
import { AuthenticationControllerSvr } from '@/service/AuthenticationControllerSvr.js'; //OrgUserMgeControllerSvr
import { HomeControllerSvr } from '@/service/HomeControllerSvr';
import { OrgUserMgeControllerSvr } from '@/service/OrgUserMgeControllerSvr/OrgUserMgeControllerSvr';
import helpIcon from '../help/helpIcon.vue';

import {
  removeUser,
  removeToken,
  setCantonList,
  getCantonList,
  getSystem,
  setSystem,
  setToken,
} from '@/utils/auth.js';
import { CantonQueryPara } from '@/models/queryparams/CantonQueryPara';
import { CantonMgeSvr } from '@/service/CantonMgeSvr';
import eaAreaMge from '@/components/common/eaAreaMge.vue';
import { isShowMenu } from '@/assets/js/division.js';
import changePassword from '@/components/container/changePassword.vue';
import headQuarters from '@/components/container/headQuarters.vue';
import { url } from '@/utils/service';
import { WechatAuthControllerSvr } from '@/service/WechatAuthControllerSvr/WechatAuthControllerSvr';
import { SysConfigServiceSvr } from '@/service/SysConfigMge/SysConfigServiceSvr';
import { CommonControllerSvr } from '@/service/CommonControllerSvr/CommonControllerSvr';
import { HomePageControllerSvr } from '@/service/HomePageControllerSvr/HomePageControllerSvr';
import { User } from '@/models/queryparams/User.js';
import { showKey, handleTitle } from '@/utils/dev-helper.js';

export default {
  components: {
    changePassword,
    headQuarters,
    eaAreaMge,
    VueScriptComponent,
    helpIcon,
  },
  props: {},
  data() {
    var validateIdentityType = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择类型'));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (!this.ruleForm.eareaName) {
        callback(new Error('请选择物业区域'));
      } else callback();
    };
    return {
      Concealtitle: true,
      obj: {
        user: {},
        contactor: '',
        telPhone: '',
        ConPassword: '',
      },
      isDelete: true, //判断是否初始化删除
      userDetial: {},
      selectArr: [],
      isMessageText: 'false',
      checkBox: 'true',
      isShowEaraName: false,
      optionsType: [],
      ruleForm: {
        eareaName: '',
        eareaCode: '',
        identityType: '',
      },
      activeName: 'third',
      input: '',
      year: '',
      month: '',
      day: '',
      active: 0,
      show: true,
      systemConfig: {},
      tabs: [
        { name: '首页', path: 'index' },
        // { name: '物业查询', path: 'queryPropertyArea' },
        // { name: '楼栋管理', path: 'buildingList' }
      ],
      isShowBtn: false,
      menuList: [],
      isCollapse: true, // 控制侧边栏是否出现
      isShowMenuSearch: false, // 控制导航搜索是否出现
      searchKeyword: '', // 搜索关键词
      restaurants: [], // 未搜索到所展示的空数组
      router: [],
      navPlus: false,
      currentNav: [],
      asidewidth: 65, //之前是80
      topRouterLink: [],
      containerHeader: 75, //之前是120
      passwordVisible: false, //密码修改模态框
      clientWidth: '',
      messageCount: 0, //消息记录总数
      rightStyle: {
        top: '',
        left: '',
      },
      showright: false,
      chooseTabindex: 0,
      activeIndex: 0,
      searchVal: '',
      showBinding: false,
      identityBind: false,
      imgurl: '',
      wechatAuthControllerSvr: new WechatAuthControllerSvr(),
      isBinding: false,
      quartersVisible: false,
      listRouter: '',
      tempTabArr: [
        {
          path: '/index',
          name: '首页',
        },
      ],
      redirectURL: '',
      showUserTypeList: false, // 显示切换角色
      listRouter: [], //存放tab数据
      showZhwyDj:false
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      addRouters: (state) => state.addRouters,
      token: (state) => state.token,
      tabsRouter: (state) => state.tabsRouter,
      userRoleInfo: (state) => state.userRoleInfo,
    }),
    mainWidth: function () {
      // return document.documentElement.clientWidth - this.asidewidth * 192;
      return document.documentElement.clientWidth - this.asidewidth;
    },
    showleft() {
      return !isShowMenu
        ? false
        : process.env.NODE_ENV === 'production' ||
            process.env.NODE_ENV === 'development'; // 2022年1月以后，所有用户都可以看到左侧评价公示菜单
      // return !isShowMenu ? false : (this.userInfo.UserParam.UserType === '主管部门用户' && process.env.NODE_ENV === 'production') || process.env.NODE_ENV === 'development';// 2022年1月以前的版本
    },
    useMetaNameList() {
      return [
        '申报草稿',
        '录入纠纷信息',
        '重复信息查看',
        '评标评审专家申报',
        '信息变更',
        '物业服务企业历史评价情况',
        '项目负责人历史评价情况',
        '调整名单',
        '批量风险名单',
        '查看风险名单详情',
        '功能优化申请详情',
        '数据修改申请详情',
        '定期审核'
      ];
    },
  },
  directives: {
    mouseToLeft: mouseToLeft,
  },
  //监听路由变化时 tab的变化
  watch: {
    $route(to, from) {
      // if(to.path=='/orgRankState'){
      //   this.Concealtitle=false;
      // }
      // if(to.path=='/orgRankState'){
      //   this.Concealtitle=false;
      // }
    },
  },
  created() {
    this.commonControllerSvr = new CommonControllerSvr();
    this.orgUserMgeControllerSvr = new OrgUserMgeControllerSvr();
    this.AuthenticationControllerSvr = new AuthenticationControllerSvr();
    this.homePageControllerSvr = new HomePageControllerSvr();
    this.homeControllerSvr = new HomeControllerSvr();
    let date = new Date();
    this._data.year = date.getFullYear();
    this._data.month = date.getMonth() + 1;
    this._data.day = date.getDate();
    this.$bus.$on('getbus', (id) => {
      this.tabsDelete(id, true);
    });
    // console.warn(res.Token);
    // setToken(res.Token);
    // store.commit('SET_TOKEN', res.Token);
  },
  mounted() {
    this.getShopCode();

    this.commonControllerSvr
      .GetSysSettingByString(this.token, 'isOpenUserSignsNullVerification')
      .then((res) => {
        if (res === 'true') {
          if (!this.userInfo.UserParam.UserSigns) {
            this.identityBind = true;
          }
        }
      });
    this.commonControllerSvr
      .GetConfigValueList('用户标签-' + this.userInfo.UserParam.UserType)
      .then((res) => {
        if (res) {
          // this.optionsType = [];
          var myArray = new Array();
          for (let qx of res) {
            if (qx.Key.indexOf('管理员') != -1) {
              qx.lable = '企业人员，企业报表填报人员';
              myArray.push(qx);
              this.ruleForm.identityType = qx.Key;
            } else if (qx.Key.indexOf('项目经理') != -1) {
              qx.lable = qx.Key;
              myArray.push(qx);
            }
          }
          this.optionsType = myArray;
        }
      });
    this.AuthenticationControllerSvr.getUserDetail(this.token, 1).then(
      (res) => {
        this.user = res;
        window.sessionStorage.setItem('role', res.UserParam.UserSigns);
      }
    );
    this.getLoginCode();
    this.wechatAuthControllerSvr.CheckBindSuccess(this.token).then((res) => {
      this.isBinding = res;
    });
    if (!getCantonList()) {
      let par = new CantonQueryPara();
      par.setParamByCantonCode('');
      new CantonMgeSvr().GetCantonList(this.token, par, false).then((res) => {
        let obj = {};
        for (let item of res._Items) {
          obj[item.CantonCode] = item.CantonName;
        }
        setCantonList(obj);
      });
    }
    var configstr = getSystem();
    if (configstr === undefined || configstr === null || configstr === '') {
      new SysConfigServiceSvr()
        .getSystemConfig('BisWebSiteName')
        .then((res) => {
          this.systemConfig = res;
          handleTitle(this.systemConfig.BisWebSiteName);
          setSystem(res);
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    } else {
      this.systemConfig = configstr;
      if (this.systemConfig.BisWebSiteName) {
        handleTitle(this.systemConfig.BisWebSiteName);
      } else {
        this.systemConfig = JSON.parse(getSystem());
        handleTitle(this.systemConfig.BisWebSiteName);
      }
    }
    // setInterval(() => {
    //   this.wechatAuthControllerSvr.CheckBindSuccess(this.token).then(res => {
    //     this.isBinding = res;
    //   });
    // }, 30000);
    this.imgurl = url + 'GetEmployeeQrCode?token=' + this.token;
    if (process.env.NODE_ENV === 'development') {
      this.router = this.addRouters[0].children.filter((item) => {
        return item.name == '物业服务信息评价公示';
      });
      // this.router = this.addRouters[0].children.filter((item) => {
      //   return item.children.some((_item) => {
      //     return _item.meta.isShowMenu;
      //   });
      // });
      // this.router.forEach((item) => {
      //   if (item.name === '物业服务信息评价') {
      //     item.children.forEach((child) => {
      //       if (child.meta.userType && child.meta.userType == 5) {
      //         child.meta.isShowMenu = true;
      //       }
      //       if (this.userInfo.ExParam.indexOf('市局用户') > -1) {
      //         if (child.name == '我的工作') {
      //           child.children.forEach((item) => {
      //             if (
      //               item.name == '录入良好信息' &&
      //               this.userInfo.UserParam.Remark3.indexOf('322') > -1
      //             ) {
      //               item.meta.isShowMenu = true;
      //             }
      //           });
      //         }
      //       }
      //     });
      //   }
      // });
      if (
        this.userInfo.ExParam.indexOf('物业服务信息评价') != -1 &&
        this.userInfo.UserParam.UserType === '主管部门用户'
      ) {
        let addRouter = this.addRouters[0].children.filter((item) => {
          return item.name == '物业服务信息评价';
        });
        addRouter[0].children.forEach((child) => {
          if (this.userInfo.LoginId == '185****9736') {
            // console.log(child.meta.userType);
            if (child.meta.userType == 5) {
              child.meta.isShowMenu = true;
            } else {
              child.meta.isShowMenu = false;
            }
          } else if (this.userInfo.ExParam.indexOf('市局用户') > -1) {
            if (child.meta.userType != 3 && child.meta.userType != 4) {
              child.meta.isShowMenu = false;
            } else if (child.name == '我的工作') {
              child.children.forEach((item) => {
                if (
                  item.name == '录入良好信息' &&
                  this.userInfo.UserParam.Remark3.indexOf('322') > -1
                ) {
                  item.meta.isShowMenu = true;
                } else if (item.name == '风险名单认定') {
                  item.meta.isShowMenu = false;
                } else if (
                  item.name == '不良信息认定' &&
                  this.userInfo.UserParam.Remark3.indexOf('322') == -1
                ) {
                  item.meta.isShowMenu = false;
                }
              });
            }
          } else {
            if (child.meta.userType != 3) {
              //区局用户开发项目负责人管理菜单
              if (this.userInfo.ExParam.indexOf('区局用户') > -1&&child.name=='基础信息管理'){
                child.children.forEach((item) => {
                  if (item.name == '项目负责人管理' ) {
                    item.meta.isShowMenu = true;
                  }else{
                    item.meta.isShowMenu = false;
                  }
                });
              }else{
                child.meta.isShowMenu = false;
              }
            } else if (child.name == '我的工作') {
              child.children.forEach((item) => {
                if (
                  item.name == '风险名单认定' &&
                  this.userInfo.UserParam.Remark3.indexOf('352') == -1
                ) {
                  item.meta.isShowMenu = false;
                } else if (
                  item.name == '不良信息认定' &&
                  this.userInfo.UserParam.Remark3.indexOf('352') == -1
                ) {
                  item.meta.isShowMenu = false;
                }
              });
            }
          }
          if (child.name == '风险名单管理') {
            //只有322 显示待确认风险名单管理
            if (this.userInfo.UserParam.Remark3.indexOf('322') == -1) {
              child.children.find(
                (item) => item.name == '待确定风险名单管理'
              ).meta.isShowMenu = false;
            }
          }
        });
        // let toOwnerRouter = addRouters[0].children.filter((item) => {
        //   return item.name == '业主组织决策系统';
        // });
        this.router = [...this.router, ...addRouter];
      }
      if (
        // 专家库权限换了之后
        this.userInfo.UserParam.Remark3.indexOf('520') > -1 ||
        this.userInfo.UserParam.Remark3.indexOf('521') > -1 ||
        this.userInfo.UserParam.Remark3.indexOf('522') > -1 ||
        this.userInfo.UserParam.Remark3.indexOf('523') > -1 ||
        this.userInfo.UserParam.Remark3.indexOf('524') > -1 ||
        this.userInfo.UserParam.Remark3.indexOf('525') > -1
        // 权限更改之前
        // this.userInfo.UserParam.Remark3.indexOf('322') > -1 ||
        // this.userInfo.UserParam.Remark3.indexOf('321') > -1 ||
        // this.userInfo.UserParam.Remark3.indexOf('320') > -1 ||
        // this.userInfo.UserParam.Remark3.indexOf('302') > -1 ||
        // this.userInfo.UserParam.Remark3.indexOf('301') > -1
      ) {
        let addRouter = this.addRouters[0].children.filter((item) => {
          return item.name == '专家管理';
        });
        addRouter[0].children = addRouter[0].children.filter(
          (item) => item.name != '查看免考名单'
        );
        addRouter[0].children.forEach((child) => {
          if (child.meta.iszj) {
            child.meta.isShowMenu = true;
          } else {
            child.meta.isShowMenu = false;
          }
          if (this.userInfo.UserParam.Remark3.indexOf('520') > -1) {
            if (child.meta.isly) {
              child.meta.isShowMenu = true;
            }
          }
        });
        this.router = [...this.router, ...addRouter];
      }
      if (this.userInfo.DeptType == '市局') {
        //需求管理临时处理
        let tempRouter = this.addRouters[0].children.filter((item) => {
          return item.name == '需求管理';
        });
        this.router = [...this.router, ...tempRouter];
        if (
          this.userInfo.Description == '经办人员' &&
          this.userInfo.UserParam.Remark3.indexOf('540') > -1
        ) {
          //租户菜单
          let tenantRouter = this.addRouters[0].children.filter((item) => {
            return item.name == '保障房租户绑定';
          });
          this.router = [...this.router, ...tenantRouter];
        }
      } else if (this.userInfo.DeptType == '区局') {
        //需求管理临时处理
        let tempQuRouter = this.addRouters[0].children.filter((item) => {
          return item.name == '需求管理';
        });
        tempQuRouter[0].children = tempQuRouter[0].children.filter((item) => {
          return item.name == '审核列表' || item.name == '数据修改申请';
        });
        this.router = [...this.router, ...tempQuRouter];
      }
      this.commonControllerSvr
      .getSysParamValueByType('if_show_szzhwy_pc')
      .then((res) => {
        if (res === 'true') {
          if(this.userInfo.DeptType == '物业服务企业'){
            let tempRouter = this.addRouters[0].children.filter((i)=>{
              return i.name == '智慧物业对接平台';
            });
            this.router = [...this.router, ...tempRouter];
          }
        }
      });
    }
    if (process.env.NODE_ENV === 'production') {
      // development  production
      this.router = this.addRouters[0].children.filter((item) => {
        return item.name == '物业服务信息评价公示';
      });
      let totoOwner = this.addRouters[0].children.filter((item) => {
        return item.name == '业主组织决策系统';
      });
      if (
        this.userInfo.ExParam.indexOf('物业服务信息评价') != -1 &&
        this.userInfo.UserParam.UserType === '主管部门用户'
      ) {
        let addRouter = this.addRouters[0].children.filter((item) => {
          return item.name == '物业服务信息评价';
        });
        addRouter[0].children.forEach((child) => {
          if (this.userInfo.LoginId == '185****9736') {
            // console.log(child.meta.userType);
            if (child.meta.userType == 5) {
              child.meta.isShowMenu = true;
            } else {
              child.meta.isShowMenu = false;
            }
          } else if (this.userInfo.ExParam.indexOf('市局用户') > -1) {
            if (child.meta.userType != 3 && child.meta.userType != 4) {
              child.meta.isShowMenu = false;
            } else if (child.name == '我的工作') {
              child.children.forEach((item) => {
                if (
                  item.name == '录入良好信息' &&
                  this.userInfo.UserParam.Remark3.indexOf('322') > -1
                ) {
                  item.meta.isShowMenu = true;
                } else if (item.name == '风险名单认定') {
                  item.meta.isShowMenu = false;
                } else if (
                  item.name == '不良信息认定' &&
                  this.userInfo.UserParam.Remark3.indexOf('322') == -1
                ) {
                  item.meta.isShowMenu = false;
                }
              });
            }
          } else {
            if (child.meta.userType != 3) {
              //区局用户开发项目负责人管理菜单
              if (this.userInfo.ExParam.indexOf('区局用户') > -1&&child.name=='基础信息管理'){
                child.children.forEach((item) => {
                  if (item.name == '项目负责人管理' ) {
                    item.meta.isShowMenu = true;
                  }else{
                    item.meta.isShowMenu = false;
                  }
                });
              }else{
                child.meta.isShowMenu = false;
              }
            } else if (child.name == '我的工作') {
              child.children.forEach((item) => {
                if (
                  item.name == '风险名单认定' &&
                  this.userInfo.UserParam.Remark3.indexOf('352') == -1
                ) {
                  item.meta.isShowMenu = false;
                } else if (
                  item.name == '不良信息认定' &&
                  this.userInfo.UserParam.Remark3.indexOf('352') == -1
                ) {
                  item.meta.isShowMenu = false;
                }
              });
            }
          }
          if (child.name == '风险名单管理') {
            //只有322 显示待确认风险名单管理
            if (this.userInfo.UserParam.Remark3.indexOf('322') == -1) {
              child.children.find(
                (item) => item.name == '待确定风险名单管理'
              ).meta.isShowMenu = false;
            }
          }
        });
        // let toOwnerRouter = addRouters[0].children.filter((item) => {
        //   return item.name == '业主组织决策系统';
        // });
        this.router = [...this.router, ...addRouter];
      }
      if (
        this.userInfo.UserParam.Remark3.indexOf('520') > -1 ||
        this.userInfo.UserParam.Remark3.indexOf('521') > -1 ||
        this.userInfo.UserParam.Remark3.indexOf('522') > -1 ||
        this.userInfo.UserParam.Remark3.indexOf('523') > -1 ||
        this.userInfo.UserParam.Remark3.indexOf('524') > -1 ||
        this.userInfo.UserParam.Remark3.indexOf('525') > -1
        // this.userInfo.UserParam.Remark3.indexOf('322') > -1 ||
        // this.userInfo.UserParam.Remark3.indexOf('321') > -1 ||
        // this.userInfo.UserParam.Remark3.indexOf('320') > -1 ||
        // this.userInfo.UserParam.Remark3.indexOf('302') > -1 ||
        // this.userInfo.UserParam.Remark3.indexOf('301') > -1
      ) {
        let addRouter = this.addRouters[0].children.filter((item) => {
          return item.name == '专家管理';
        });
        addRouter[0].children = addRouter[0].children.filter(
          (item) => item.name != '查看免考名单'
        );
        addRouter[0].children.forEach((child) => {
          if (child.meta.iszj) {
            child.meta.isShowMenu = true;
          } else {
            child.meta.isShowMenu = false;
          }
          if (this.userInfo.UserParam.Remark3.indexOf('520') > -1) {
            if (child.meta.isly) {
              child.meta.isShowMenu = true;
            }
          }
        });
        this.router = [...this.router, ...addRouter];
      }
      if (this.userInfo.DeptType == '市局') {
        //需求管理临时处理
        let tempRouter = this.addRouters[0].children.filter((item) => {
          return item.name == '需求管理';
        });
        this.router = [...this.router, ...tempRouter];
        if (
          this.userInfo.Description == '经办人员' &&
          this.userInfo.UserParam.Remark3.indexOf('540') > -1
        ) {
          //租户菜单
          let tenantRouter = this.addRouters[0].children.filter((item) => {
            return item.name == '保障房租户绑定';
          });
          this.router = [...this.router, ...tenantRouter];
        }
      } else if (this.userInfo.DeptType == '区局') {
        //需求管理临时处理
        let tempQuRouter = this.addRouters[0].children.filter((item) => {
          return item.name == '需求管理';
        });
        tempQuRouter[0].children = tempQuRouter[0].children.filter((item) => {
          return item.name == '审核列表' || item.name == '数据修改申请';
        });
        this.router = [...this.router, ...tempQuRouter];
      }
      this.commonControllerSvr
      .getSysParamValueByType('if_show_szzhwy_pc')
      .then((res) => {
        if (res === 'true') {
          if(this.userInfo.DeptType == '物业服务企业'){
            let tempRouter = this.addRouters[0].children.filter((i)=>{
              return i.name == '智慧物业对接平台';
            });
            this.router = [...this.router, ...tempRouter];
          }
        }
      });
    }
    // if(this.userInfo.DeptType == '市局'){
    // //需求管理临时处理
    // let tempRouter = this.addRouters[0].children.filter((item) => {
    //     return item.name == '需求管理';
    //   });
    //   this.router = [...this.router, ...tempRouter];
    // }

    ///
    this.restaurants = this.loadAll();
    this.homeControllerSvr.getMessageCount(this.token, 0).then((res) => {
      this.messageCount = res;
    });
    //判断企业是否关联总公司
    if (this.userInfo.UserParam.UserType === '物业服务企业用户') {
      this.homeControllerSvr.checkIsHeadOffice(this.token).then((res) => {
        if (res) {
          this.quartersVisible = false;
        } else {
          this.quartersVisible = true;
        }
      });
      // .catch(err => {});
    }
  },

  beforeRouteEnter(to, from, next) {
    next();
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeRouteLeave(to, from, next) {
    //to.meta.keepAlive = true;
    next((vm) => {
      console.warn(to.redirectedFrom);
      if (to.redirectedFrom) {
        //vue-router redirect不会刷新页面，需要判断并刷新
        // vm.$router.go(0)//safari浏览器go(0)无效
        window.location.reload();
      }
    });
  },
  //不知道谁用这种方式控制tab页新增。。。改不动其他的只能在里面加isDelete
  beforeUpdate() {
    this.mapTabs(this.$route);
  },
  methods: {
    showKey(str) {
      return showKey(str);
    },
    // 设置使用mate里的name为标签名
    getMetaName(item) {
      if (this.useMetaNameList.indexOf(item.name) > -1) {
        return true;
      } else {
        return false;
      }
    },
    getShopCode(value) {},
    ...mapMutations([
      'SET_USERINFO',
      'SET_USERROLEINFO',
      'SET_TOKEN',
      'SET_SYSTEM',
      'SET_SHOWBTN',
    ]),
    ...mapActions({
      GetTabsRouter: 'GetTabsRouter',
      DeleTabsRouter: 'DeleTabsRouter',
      DelTabsArr: 'DelTabsArr',
      DelTabsOther: 'DelTabsOther',
    }),
    ...mapMutations(['UPDATE_TABSOTHER', 'SET_SYSTEM']),
    identityTypeChange(value) {
      if (this.ruleForm.identityType === '物业服务企业项目经理') {
        this.isShowEaraName = true;
      } else {
        this.isShowEaraName = false;
      }
    },
    confirmAndRedirect() {
      this.$confirm(
        '您访问的链接即将离开“深圳市物业管理信息平台”门户网站，是否继续？',
        '提示',
        {
          confirmButtonText: '确定',
          showClose: false,
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          window.open(
            'http://bszs.conac.cn/sitename?method=show&id=080586B9F87F789DE053022819AC8A45',
            '_blank'
          );
        })
        .catch(() => {});
    },
    getICP() {
      this.$confirm(
        '您访问的链接即将离开“深圳市物业管理信息平台”门户网站，是否继续？',
        '提示',
        {
          confirmButtonText: '确定',
          showClose: false,
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          window.open('http://beian.miit.gov.cn', '_blank');
        })
        .catch(() => {});
    },
    getYGA() {
      this.$confirm(
        '您访问的链接即将离开“深圳市物业管理信息平台”门户网站，是否继续？',
        '提示',
        {
          confirmButtonText: '确定',
          showClose: false,
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          window.open(
            'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030402002800',
            '_blank'
          );
        })
        .catch(() => {});
    },
    confirmOut() {
      this.$confirm(
        '您访问的链接即将离开“深圳市物业管理信息平台”门户网站，是否继续？',
        '提示',
        {
          confirmButtonText: '确定',
          showClose: false,
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          window.open('https://www.gdzwfw.gov.cn', '_blank');
        })
        .catch(() => {});
    },
    property(value) {
      this.selectArr[0] = value;
      this.ruleForm.eareaName = '';
      this.ruleForm.eareaName = value.EaArea.EaAreaName;
      this.ruleForm.eareaCode = value.EaArea.EaAreaCode;
    },
    propertyValArr(value) {
      this.selectArr = value;
      this.ruleForm.eareaName = '';
      for (var item of value) {
        this.ruleForm.eareaName += item.EaArea.EaAreaName + ',';
        this.ruleForm.eareaCode = item.EaArea.EaAreaCode + ',';
      }
      this.ruleForm.eareaName = this.ruleForm.eareaName.substring(
        0,
        this.ruleForm.eareaName.length - 1
      );
      this.ruleForm.eareaCode = this.ruleForm.eareaCode.substring(
        0,
        this.ruleForm.eareaCode.length - 1
      );
    },
    openWyQuery() {
      this.$store.state.areasTip = true;
    },
    submitForm() {
      if (!this.ruleForm.identityType) {
        this.$message({
          type: 'warning',
          message: '请选择登录类型',
        });
        return;
      } else {
        if (this.ruleForm.identityType === '物业服务企业项目经理') {
          if (!this.ruleForm.eareaName) {
            this.$message({
              type: 'warning',
              message: '请选择物业区域',
            });
            return;
          } else {
            this.sureBtn();
          }
        } else {
          this.sureBtn();
        }
      }
    },
    sureBtn() {
      this.user.UserParam.UserSigns = this.ruleForm.identityType;
      if (this.ruleForm.eareaCode)
        this.user.UserParam.Remark1 = this.ruleForm.eareaCode;
      this.user = new User(this.user);
      this.user.Parameter = '';
      this.orgUserMgeControllerSvr
        .ModifyUser(this.token, this.user)
        .then((res) => {
          if (res === 'SUCCESS') {
            this.identityBind = false;
            this.$message({
              type: 'success',
              message: '用户类型绑定成功',
            });
            /* this.AuthenticationControllerSvr.getUserDetail(this.token, 1).then(
                  res => {
                    this.SET_USERINFO(res);
                  }
                ); */
            location.reload(true);
            /* this.$router.push({
                  path: "/index",
                  query: { work: "true" }
                }); */
          }
        });
    },
    handleOpen() {},
    handleClose() {},
    //监听浏览器窗口大小后尺寸变化
    getLoginCode() {
      this.wechatAuthControllerSvr.GetLoginCode(this.token).then((res) => {
        this.imgurl = res;
      });
    },

    onresize() {
      window.onresize = () => {
        this.clientWidth = this.setWidth();
      };
    },
    showCode() {
      this.showBinding = true;
      this.getLoginCode();
    },
    async unbound() {
      try {
        await this.$confirm('确定要解除绑定吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });

        await this.wechatAuthControllerSvr.WechatUnBind(this.token, '');
        this.isBinding = false;
        this.$message({
          type: 'success',
          message: '解绑成功',
        });
      } catch (err) {
        if (err != 'cancel') {
          this.$message({
            type: 'error',
            message: err.Msg || '解绑失败',
          });
        }
      }
    },

    setWidth() {
      // return document.documentElement.clientWidth - this.asidewidth * 192;
      return document.documentElement.clientWidth - this.asidewidth;
    },
    //个人中心
    EnterPersonalCenter() {
      this.mapTabs({ name: '个人中心', path: '/baseConfig' });
      //this.$router.push({ name: '个人中心', path: 'baseConfig' });
    },
    // 控制侧边栏展示
    showhide(isShow) {
      if (!this.isShowMenuSearch) {
        this._data.isCollapse = isShow;
        this.asidewidth = isShow ? 65 : 250;
        this.clientWidth = this.setWidth();
        // 为侧边栏第一行添加导航搜索事件
      }
    },
    // showMenuSearch() {
    //   if (this.isCollapse) {
    //     this.isCollapse = false;
    //     this.asidewidth = 250;
    //   } else {
    //     this.isShowMenuSearch = true;
    //   }
    // },
    closeMenuSearch() {
      this.isCollapse = true;
      this.isShowMenuSearch = false;
      this.asidewidth = 65;
    },
    // menu异步搜索函数
    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    // 格式化关键词
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    // 暂时不知道干嘛的，用在搜索框里的
    handleSelect() {},
    loadAll() {
      // 搜索框请求数据接口
      return [{ value: '三全鲜食', address: '长宁区新渔路144号' }];
    },
    //自定义导航
    handelNavGroup() {
      this.navPlus = !this.navPlus;
    },
    goIndex() {
      this.$router.push('index');
    },
    goback() {
      this.$router.back(-1);
    },
    goRouter(router) {
      this.$router.push(router.children[0].path);
    },
    logout() {
      this.commonControllerSvr
        .GetSysSettingByString(' ', 'redirect2SSOURLLogOut')
        .then((res) => {
          if (res == '') {
            removeUser();
            removeToken();
            this.$store.commit('SET_TOKEN', null);
            this.$store.commit('SET_USERINFO', null);
            // this.getSystemConfig('login');
            this.$router.push('login'); //回到首页， 再由首页判断进入维修金或 物业首页
            // location.reload();
          } else {
            if (this.token) {
              this.AuthenticationControllerSvr.logout(this.token).then(() => {
                removeUser();
                removeToken();
                this.$store.commit('SET_TOKEN', null);
                this.$store.commit('SET_USERINFO', null);
                // this.getSystemConfig('login');
                // this.$router.push('login'); //回到首页， 再由首页判断进入维修金或 物业首页
                // location.reload();
                window.location.href = res;
              });
            } else {
              removeUser();
              removeToken();
              window.location.href = res;
            }
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
      // this.AuthenticationControllerSvr.logout(this.token).then(() => {
      //   // removeUser();
      //   // this.$store.commit('SET_TOKEN', null);
      //   // this.$store.commit('SET_USERINFO', null);

      //   // this.getSystemConfig('login');
      //   // this.$router.push('login'); //回到首页， 再由首页判断进入维修金或 物业首页
      //   // location.reload();
      // });
    },
    getSystemConfig(next) {
      new SysConfigServiceSvr()
        .getSystemConfig('redirect2SSOURL')
        .then((res) => {
          if (res === null || res === '' || !res.redirect2SSOURL) {
            this.$router.push(next);
            location.reload();
          } else {
            window.location.href = res.redirect2SSOURL;
            return;
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    //tabs点击事件
    tabsHandle(route, idx) {
      this.$router.push({
        path: route.path,
        query: route.query,
      });
      this.activeIndex = idx;
    },

    linkTo(router) {
      let flag = true;
      for (let i = 0; i < this.tabsRouter.length; i++) {
        if (this.tabsRouter[i].path === router) {
          flag = false;
        }
      }
      if(router == '/toZhwydjpt'){
        debugger
        let windowUrl = window.location.href;
        this.$router.go(-1);
        let timeStamp = new Date().getTime();
        //预生产
        if(windowUrl.indexOf('172.31.1.58')!=-1){
          window.open(
            'http://172.31.1.52:8005/szwyfwpt/open_web/LoginManageExtendController/login_new?token=' +
              this.token +
              '&code=' +
              localStorage.getItem('code') +
              '&t=' +
              timeStamp
          );
          return;
        }
        if (process.env.NODE_ENV === 'development') {
          window.open(
            'http://10.1.8.21:9020/kfpt/admin/LoginManageExtendController/login_new?token=' +
              this.token +
              '&code=' +
              localStorage.getItem('code') +
              '&t=' +
              timeStamp
          );
        }else if (process.env.NODE_ENV === 'production') {
          window.open(
            'https://zjj.sz.gov.cn/szwyfwpt/kfpt/LoginManageExtendController.assx/login_new?token=' +
              this.token +
              '&code=' +
              localStorage.getItem('code') +
              '&t=' +
              timeStamp
          );
        }
      }else{
        if (!flag) {
          this.$router.push({
            path: router,
            query: {
              t: '',
            },
          });
        } else {
          this.$router.push({
            path: router,
            query: {
              t: Date.now(),
            },
          });
        }
      }
    },

    mapTabs(route) {
      if (this.tabsRouter.length == 1) {
        this.isDelete = true;
      }
      //isDelete 点了关闭tab 如果点了就不让他新增路由，不然刷新以后删除会二次添加，不知道哪个人才写的这个方法。。。。
      if (this.isDelete) {
        if (this.tabsRouter.some((tab) => tab.name === route.name)) {
          for (let i = 0; i < this.tabsRouter.length; i++) {
            if (this.tabsRouter[i].path === route.path) {
              this.activeIndex = i;
              this.UPDATE_TABSOTHER({ route: route, index: i });
              this.tabsHandle(route, i);
              break;
            }
          }
        } else {
          this.GetTabsRouter(route).then((res) => {
            this.activeIndex = this.tabsRouter.length - 1;
            const routerLink = document.querySelector('.routerLink');
            const scorllTab = document.querySelector('.scorllTab');
            this.tabsHandle(route, this.tabs.length - 1);
            if (scorllTab.offsetWidth > routerLink.offsetWidth) {
              scorllTab.style.left =
                parseFloat(routerLink.offsetWidth) -
                parseFloat(scorllTab.offsetWidth) +
                'px';
              this.isShowBtnHandle(true);
            } else {
              this.isShowBtnHandle(false);
            }
          }); //存进VUEX
        }
      } else {
        this.isDelete = true;
        console.log(this.isDelete);
      }
    },
    //tabs删除事件
    async tabsDelete(idx, bool) {
      // if (
      //   this.tabsRouter.length != 0 &&
      //   this.tabsRouter[idx]?.name == '报表填报'
      // ) {
      //   // 先发送消息给 iframe
      //   var iframe = document.getElementById('childIframe');
      //   iframe.contentWindow.postMessage('close-save-message', '*');
      //   console.log('已发送关闭保存消息');
      //   // 等待 iframe 回应消息后再继续执行
      //   await new Promise((resolve) => {
      //     const messageHandler = (event) => {
      //       console.log('收到消息', event);
      //       if (event.data && event.data.closeHandle) {
      //         console.log('收到关闭处理消息');
      //         window.removeEventListener('message', messageHandler);
      //         resolve();
      //       }
      //     };
      //     window.addEventListener('message', messageHandler);
      //   });
      // }
      if (idx < 1) {
        this.$message({
          type: 'warning',
          message: '首页不能关闭',
        });
        return;
      }
      this.beforeDelTabs(idx);
      console.log('走了');
      this.isDelete = false;
      this.DeleTabsRouter(idx).then(() => {
        this.tempTabArr = this.tabsRouter; //测试路由缓存问题
      });
      this.tabsHandle(
        this.tabsRouter[this.tabsRouter.length - 1],
        this.tabsRouter.length - 1
      );
      const routerLink = document.querySelector('.routerLink');
      const scorllTab = document.querySelector('.scorllTab');
      if (scorllTab.offsetWidth < routerLink.offsetWidth) {
        scorllTab.style.left = 0;
        this.isShowBtnHandle(false);
      } else {
        scorllTab.style.left =
          parseFloat(routerLink.offsetWidth) -
          parseFloat(scorllTab.offsetWidth) +
          'px';
      }
    },
    // 删除tab前处理vuex里的数据
    beforeDelTabs(idx) {
      switch (this.tabsRouter[idx].path) {
        case '/contradictTrendList':
          this.$store.commit('SET_TRENDAREALIST', []);
          this.$store.commit('SET_TRENDCODE', '');
          break;
        case '/contradictSourceList':
          this.$store.commit('SET_SOURCEAREALIST', []);
          this.$store.commit('SET_SOURCECODE', '');
          break;
        case '/duplicateAccessList':
          this.$store.commit('SET_ACCESSAREALIST', []);
          this.$store.commit('SET_ACCESSCODE', '');
          break;
      }
    },
    // 查看消息
    showMessage() {
      this.$router.push({
        path: '/messageList',
      });
    },
    // tab左滑动
    leftHandle() {
      const scorllTab = document.querySelector('.scorllTab');
      if (parseFloat(scorllTab.style.left) < 0) {
        scorllTab.style.left = '0px';
      }
    },
    rightHandle() {
      const scorllTab = document.querySelector('.scorllTab');
      const routerLink = document.querySelector('.routerLink');
      if (
        parseFloat(scorllTab.offsetWidth) > parseFloat(routerLink.offsetWidth)
      ) {
        scorllTab.style.left =
          parseFloat(routerLink.offsetWidth) -
          parseFloat(scorllTab.offsetWidth) +
          'px';
      }
    },
    // 出现滑动按钮
    isShowBtnHandle(isVal) {
      this.isShowBtn = isVal;
    },
    //密码对话框显示隐藏
    showPasswordDialog() {
      this.passwordVisible = false;
    },
    //绑定总公司
    showquartersDialog() {
      this.$message({ message: '请先关联总公司', type: 'warning' });
    },
    rightShow(e, index) {
      let time = setTimeout(() => {
        this.showright = true;
        this.rightStyle.top = e.pageY + 'px';
        this.rightStyle.left = e.pageX + 'px';
        this.chooseTabindex = index + 1;
        clearTimeout(time);
      }, 100);
    },
    hiddenRight() {
      this.showright = false;
    },
    closetabs(type) {
      if (type === 'left') {
        if (
          this.activeIndex !== 0 &&
          this.activeIndex + 1 < this.chooseTabindex
        ) {
          this.tabsHandle(this.tabsRouter[0], 0);
        }
        this.DelTabsArr({ idx: 1, len: this.chooseTabindex - 2 });
      } else if (type === 'right') {
        if (this.activeIndex + 1 > this.chooseTabindex) {
          this.tabsHandle(
            this.tabsRouter[this.chooseTabindex - 1],
            this.chooseTabindex - 1
          );
        }
        this.DelTabsArr({
          idx: this.chooseTabindex,
          len: this.tabsRouter.length - this.chooseTabindex + 1,
        });
      } else if (type === 'others') {
        if (this.activeIndex + 1 !== this.chooseTabindex) {
          this.tabsHandle(
            this.tabsRouter[this.chooseTabindex - 1],
            this.chooseTabindex - 1
          );
        }
        // this.tabsRouter = [this.tabsRouter[0], this.tabsRouter[this.chooseTabindex - 1]];
        this.DelTabsOther(this.chooseTabindex - 1);
      }
      // this.$nextTick(()=>{
      //   const scorllTab = document.querySelector('.scorllTab');
      //   const routerLink = document.querySelector('.routerLink');
      //   if (
      //     parseFloat(scorllTab.offsetWidth) < parseFloat(routerLink.offsetWidth)
      //   ) {
      //     scorllTab.style.left = 0;
      //   }
      // })
      setTimeout(() => {
        const scorllTab = document.querySelector('.scorllTab');
        const routerLink = document.querySelector('.routerLink');
        if (
          parseFloat(scorllTab.offsetWidth) < parseFloat(routerLink.offsetWidth)
        ) {
          scorllTab.style.left = 0;
        }
      }, 100);
    },
    EnterSearch() {
      if (this.searchVal) {
        this.$router.push({
          name: '综合查询',
          path: '/search',
          query: { searchVal: JSON.stringify(this.searchVal) },
        });
      } else {
        this.$message('请输入搜索内容');
      }
    },
    // 切换角色
    showUserTypeSelect() {
      this.showUserTypeList = true;
    },
    // 选择角色token:String, roleId:String   updateDefaultRole
    handleSelectUser(val) {
      //homePageControllerSvr
      if (val.Id == this.userRoleInfo.ID) {
        this.showUserTypeList = false;
        return;
      }
      this.homePageControllerSvr
        .updateDefaultRole(this.token, val.Id)
        .then((res) => {
          if (res == true || res == 'true') {
            this.$router.replace('/index');
            window.location.reload();
          } else {
            this.$message({
              type: 'error',
              message: '切换用户失败！',
            });
            this.showUserTypeList = false;
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    goHome() {
      this.$router.push('index'); //回到首页
    },
  },
};
</script>
<style lang="scss">
.sel-input {
  flex: 1;
  transition: all 1s;

  .el-input {
    max-width: 500px;

    .el-input__inner {
      border-radius: 20px;
    }
  }
}
</style>

<style lang="scss" scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #fff;
  font-size: 14px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.el-container {
  background: #f3f5f9;
  font-size: 14px;

  .container-heaedr {
    height: 111px;
  }

  section {
    width: 100%;
    // min-height: calc(100vh - 127px);
    min-height: calc(100vh - 65px);
  }

  .menu-left {
    position: absolute;
    height: 100%;
    background: #fff;
    overflow: hidden;
    box-sizing: border-box;
    padding-bottom: 56px;

    .iconStyle {
      position: relative;
      top: 5px;
      margin-right: 10px;
      font-size: 24px;
    }

    .open {
      background: #fff;
      width: 64px;
      height: 56px;
      position: fixed;
      top: calc(100vh - 56px);
      left: 0;
      z-index: 99;
      cursor: pointer;

      i {
        margin: 0;
        width: 100%;
        height: 100%;
        position: relative;
        color: #909399;

        &::before {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-top: -12px;
          margin-left: -12px;
        }
      }
    }

    .close {
      background: #fff;
      width: 250px;
      height: 56px;
      position: fixed;
      top: calc(100vh - 56px);
      left: 0;
      z-index: 99;
      cursor: pointer;

      i {
        margin: 0;
        width: 100%;
        height: 100%;
        font-size: 24px;
        position: relative;
        color: #909399;

        &::before {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-top: -12px;
          margin-left: -12px;
        }
      }
    }
  }

  .el-header {
    padding: 0;

    .nav {
      color: #fff;
      height: 65px;
      //padding-left: 80px;
      background: #1890ff;
      width: 100%;
      font-size: 18px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .logo {
        width: 50px;
        height: 50px;
        margin-top: 8px;
        margin-right: 8px;
      }

      .navRight {
        display: flex;
        justify-content: flex-end;
        // height: 7px;
        line-height: 65px;
        padding-right: 32px;

        li {
          margin: 0 12px;

          &.binding {
            margin-right: 0;
          }

          cursor: pointer;

          .el-input {
            height: 40px;

            .el-input__inner {
              height: 40px;
            }
          }

          .iconstyle {
            margin-right: 6px;
          }
        }
      }

      // .el-menu--horizontal > .el-menu-item {
      //   border-bottom: none;
      //   height: 50px;
      //   line-height: 50px;
      // }
      // .el-menu-demo {
      //   width: 800px;
      // }
      .menuList {
        width: 50%;
        display: flex;
        height: 55px;
        line-height: 55px;

        li {
          padding: 0 12px;
          cursor: pointer;

          &:hover {
            background: #3082da;
          }
        }

        .active {
          background: #3082da;
        }
      }
    }
  }

  .el-aside {
    width: 80px;
    transition: width 0.5s;
    position: relative;
    overflow-y: hidden;

    &:hover {
      overflow-y: auto;
    }
  }

  .el-main {
    // padding: 0 20px;
    padding: 0;
    overflow: hidden;
    margin-right: 10px;
    margin-left: 10px;
    margin-bottom: 10px;

    &.pagebox {
      // height: calc(100vh - 125px);
      overflow: auto;
      overflow-x: hidden;
      height: 100%;
      // background: #fff;
    }
  }

  .menuSearchBox {
    background: #fff;
    width: 800px;
    height: calc(100vh - 127px);
    padding: 40px 30px;
    box-sizing: border-box;
    box-shadow: 4px 0 8px 0 rgba(0, 0, 0, 0.2);
    position: absolute;
    z-index: 8;
    top: 104px;
    transform: translate3d(-800px, 0, 0);
    transition: transform 1s;
    overflow-y: auto;

    .close {
      position: absolute;
      right: 15px;
      top: 15px;
      cursor: pointer;
    }

    .header {
      margin-bottom: 20px;
    }

    .menu-search {
      .el-autocomplete {
        width: 80%;
      }
    }

    .menu-box-container {
      padding-top: 10px;
      column-count: 3;
      column-gap: 0;
      column-width: 200px;

      .module {
        break-inside: avoid;
        margin-right: 5%;
        margin-bottom: 20px;

        .module-title {
          margin: 5px 0 15px 0;
          font-size: 18px;
          font-weight: bold;
        }

        &:nth-child(3n) {
          margin-right: 0;
        }

        li {
          margin: 5px 0;
          font-size: 14px;
          color: #000;
          opacity: 0.65;
          line-height: 30px;
          cursor: pointer;

          &:hover {
            background: #f0f0f0;
          }
        }
      }
    }
  }

  .menuSearchBoxShow {
    transform: translate3d(250px, 0, 0);
  }

  .top {
    width: 100%;
    height: 80px;
    background: #4a94df;
  }

  .tit {
    width: 440px;
    height: 65px;
    background: url('../../assets/topTit.png') center center no-repeat;
  }

  .search {
    width: 303px;
    height: 30px;
    border-radius: 24px;
    background: #fff;
  }

  .search-inp {
    border: none;
    outline: none;
  }

  i {
    margin: 0 15px;
  }

  .top-right {
    width: 700px;
    margin-right: 20px;
  }

  .show-btn {
    position: absolute;
    right: 0;
  }

  .sidebar {
    height: 100%;
  }

  .currentPages {
    display: flex;
    position: relative;
    background: #fff;
    margin: 0 0 12px 0;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    overflow: hidden;

    .el-breadcrumb {
      padding: 12px 0;
      font-size: 18px;
    }

    // .return {
    //   text-align: center;
    //   line-height: 34px;
    //   width: 80px;
    //   border-right: 16px solid #f3f5f9;
    //   color: #4abbff;
    // }
    .breadcrumb {
      width: 100%;
      height: 40px;
      line-height: 38px;
      // padding: 0 30px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ddd;

      .left-btn {
        height: 100%;
        display: inline-block;
        width: 40px;
        // transition: all .3s;
        overflow: hidden;

        i {
          color: #a7a7a7;
          cursor: pointer;
          transition: all 0.3s;

          &:hover {
            color: #333;
          }
        }
      }

      .right-btn {
        height: 100%;
        display: inline-block;
        overflow: hidden;
        width: 40px;
        // transition: all .3s;
        i {
          color: #a7a7a7;
          cursor: pointer;
          transition: all 0.3s;

          &:hover {
            color: #333;
          }
        }
      }

      .routerLink {
        flex: 1;
        height: 100%;
        overflow: hidden;
        position: relative;

        a {
          line-height: 34px;
          padding: 0 16px;
          color: #4895e0;
          text-decoration: none;

          &:active {
            color: #4895e0;
          }
        }

        ul {
          height: 100%;
          white-space: nowrap;
          display: inline-block;
        }

        .tabs-item {
          padding: 0 24px;
          height: 30px;
          margin-right: 6px;
          line-height: 30px;
          position: relative;
          color: #6d6d6d;
          transition: all 0.3s;
          display: inline-block;
          border-bottom: 1px solid #fff;
          cursor: pointer;

          i {
            position: absolute;
            color: #ddd;
            right: -10px;
            top: 8px;
            // display: none;
          }

          &:hover {
            color: #298fee;

            i {
              display: block;

              &:hover {
                color: #666;
              }
            }
          }
        }

        .active {
          color: #1890ff !important;
          transition: all 0.3s;
          border-bottom: 1px solid #1890ff;
        }

        .scorllTab {
          position: absolute;
          transition: all 0.3s;
          top: 0;

          .box-card {
            position: fixed;
            z-index: 666;

            .el-card__body {
              div {
                font-size: 14px;
                line-height: 28px;
                cursor: pointer;

                &:hover {
                  color: #1890ff;
                }

                i {
                  margin: 0 6px;
                }
              }
            }
          }
        }
      }

      .return {
        width: 200px;
        min-width: 200px;
        text-align: right;

        span {
          line-height: 34px;
          color: #4895e0;
          cursor: pointer;
        }
      }
    }
  }

  .fl-l {
    float: left;
  }

  .bg-g {
    background: #4a5979;
  }

  .rotate {
    transform: rotateY(180deg);
  }
}

.footer {
  display: flex;
  justify-content: space-around;

  .footer-box {
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    .bold {
      font-weight: bolder;
    }
  }
}

body {
  margin: 0;
  padding: 0;
  background: #fff;
  color: #666;
  color: #333;
  font: 14px/1.5 'Microsoft YaHei', 微软雅黑;
}

div,
dl,
dt,
td,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
legend,
p,
blockquote {
  list-style: none;
  margin: 0;
  padding: 0;
}

a {
  color: #333;
  text-decoration: none;
  cursor: pointer;
}

@font-face {
  font-family: 'iconfont';
}

.iconfont {
  font-family: 'iconfont' !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-vertical_line:before {
  content: '|';
}

.icon-home:before {
  //content: "\e60f";
  font-size: 2rem;
}

.icon-wode:before {
  content: '\e60c';
  font-size: 2rem;
}

.icon-tuichu:before {
  content: '\e60a';
  font-size: 2rem;
}

.container {
  width: 100%;
  padding-bottom: 10px;
  position: absolute;
  border-bottom: 1px solid #dfe1e2;
}

.header-hd-wrapper {
  width: 100%;
  padding: 1rem;
}

.header-hd .header-main {
  white-space: nowrap;
  display: flex;
  align-items: center;
}

.header-logo-gov {
  position: relative;
  margin: 0 !important;
}

.header-logo {
  margin: 0;
  font-weight: 700;
  line-height: 5.2rem;
  display: inline-block;
  vertical-align: middle;
  float: left;
}

.header-logo-gov {
  padding-right: 0.15rem;
}

.header-l a {
  position: absolute;
}

.header-logo a {
  display: block;
  color: #0d1c28;
  text-decoration: none;
  background: url(../../assets/img/menu/gdzw-logo.png) no-repeat 0 transparent;
  background-size: contain !important;
  width: auto;
  height: 5.4rem;
  color: transparent !important;
  text-indent: 100%;
  white-space: nowrap;
  overflow: hidden;
}

.header-title {
  font-size: 2rem;
  font-weight: 700;
  margin-right: 0.25rem;
  height: 1.8rem;
  line-height: 5.2rem;
  float: left;
}

.header-title2 {
  font-size: 1.8rem;
  font-weight: 700;
  margin-right: 0.25rem;
  height: 1.8rem;
  line-height: 5.2rem;
  float: left;
}

.header {
  border-bottom: 1px solid #dfe1e2;
  min-height: 50px;
}

.header-container {
}

.header-main {
  //width: 65%;
  float: left;
  display: inline-block;
  vertical-align: middle;
}

.header-aside {
  //width: 35%;
  float: right;
}

.header-aside > li {
  float: right;
  padding: 0 0.6rem;
  line-height: 5.2rem;
}

.header-aside > li a {
  color: white;
  text-decoration: none;
  display: inline-block;
  font-style: normal;
  vertical-align: top;
}

.header-aside li .user-aside-title {
  max-width: 9em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media screen and (min-width: 300px) and (max-width: 1024px) {
  .header-main {
    width: 100%;
    float: left;
    min-height: 80px;
  }
  .header-aside {
    width: 100%;
    float: left;
  }
  .header-aside > li {
    float: left;
  }
  .icon-vertical_line:before {
    display: none;
  }
}

// 通用代码，控制整体页面样表
body {
  margin: 0;
  padding: 0;
  background: #fff;
  color: #666;
  color: #333;
  font: 14px/1.5 'Microsoft YaHei', 微软雅黑;
}

div,
dl,
dt,
td,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
legend,
p,
blockquote {
  list-style: none;
  margin: 0;
  padding: 0;
}

a {
  color: #333;
  text-decoration: none;
  cursor: pointer;
}

/**
 * 主体样式
 */
.container {
  width: 100%;
}

.footer {
  background: #f1f2f3;
  border-top: 1px solid #dfe1e2;
  min-height: 120px;
}

.footer-container {
  margin: 20px 7%;
  width: 100%;
}

.footer-l {
  width: 65%;
  float: left;
}

.footer-r {
  width: 35%;
  float: right;
}

.footer-l b {
  float: left;
}

.footer li {
  float: left;
  line-height: 30px;
}

.footer li dd {
  line-height: 30px;
}

.footer-l li:nth-child(1) {
  width: 100%;
}

.footer-l li:nth-child(2) {
  width: 30%;
}

.footer-l li:nth-child(3) {
  width: 25%;
}

.footer-l li:nth-child(4) {
  width: 45%;
}

.footer-l img {
  height: 25px;
  width: auto;
  vertical-align: middle;
}

.footer-r li:nth-child(1) {
  width: 40%;
  position: relative;
}

.footer-r li:nth-child(2) {
  width: 60%;
  position: relative;
}

.footer-r img {
  height: 58px;
  width: auto;
  margin-left: 30px;
  vertical-align: middle;
}

xmp {
  background: #000;
  color: #fff;
}
.el-footer {
  padding: 0px;
}
/**
 * 手机端样式
 */

@media screen and (min-width: 300px) and (max-width: 1024px) {
  .footer {
    position: absolute;
    padding-bottom: 20px;
  }
  .footer-l {
    width: 100%;
    float: left;
  }
  .footer-r {
    width: 100%;
    float: right;
  }
  .footer-l b {
    float: left;
  }
  .footer li {
    float: left;
    line-height: 36px;
  }

  .footer-l li:nth-child(1) {
    width: 100%;
  }
  .footer-l li:nth-child(2) {
    width: 100%;
  }
  .footer-l li:nth-child(3) {
    width: 100%;
  }
  .footer-l li:nth-child(4) {
    width: 100%;
  }
  .footer-r li:nth-child(1) {
    width: 40%;
    position: relative;
    line-height: 30px;
  }
  .footer-r li:nth-child(2) {
    width: 60%;
    position: relative;
  }
}
</style>
<style lang="scss">
.navRight {
  li {
    .el-input {
      height: 35px;

      .el-input__inner {
        height: 35px;
      }
    }
  }

  .item {
    .el-badge__content {
      top: 22px;
      right: 18px;
    }
  }
}

.menu-left {
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 250px;
    min-height: 400px;
    overflow-y: hidden;

    &:hover {
      overflow-y: auto;
    }

    .el-submenu {
      span {
        font-size: 14px;
      }
    }

    .el-menu-item {
      font-size: 12px;
      // background: #ecf5ff;
    }
    .menu-item-1{
      font-size: 14px;
    }
  }

  .el-menu-item {
    &.is-disabled {
      opacity: 1;
      cursor: pointer;
    }
  }
}

.el-header {
  .nav {
    .el-menu-demo {
      overflow-x: auto;
    }

    .el-menu--horizontal {
      & > .el-submenu {
        .el-submenu__title {
          border-bottom: none;
          height: 50px;
          line-height: 50px;
        }
      }
    }
  }
}

.scorllTab {
  .box-card {
    .el-card__body {
      padding: 8px 8px 8px 2px;
    }
  }
}

.user-box {
  .user-list {
    border-bottom: 1px solid #ccc;
    cursor: pointer;
    box-sizing: border-box;
    padding: 10px;
  }

  .activeUser {
    background: #1890ff;
    color: #fff;
  }
}
</style>
